import { Component, Prop, State, Watch, h } from '@stencil/core';

@Component({
  tag: 'input-multiline',
  styleUrl: 'input-multiline.css',
})
export class InputMultiline {
  @State() inputValue: string = '';
  @Prop() errorMessage: string = '';
  @Prop() isDisabled: boolean = false;
  @Prop() hasError: boolean = false;
  @Prop() label: string = '';
  @Prop() maxLength: number = 1000;
  @Prop() rowCount: number = 2;
  @Prop() shouldDisplayCharCount: boolean = false;
  @Prop() value: string = '';
  @Prop() whenChanged: (value: string) => void = () => {};

  @Watch('value')
  objectDataWatcher(newOptionsValue) {
    this.inputValue = newOptionsValue;
  }

  componentWillLoad() {
    this.inputValue = this.value;
  }

  onInputChange(e) {
    this.inputValue = e.target.value;
    this.whenChanged(e.target.value);
  }

  remainingCharacterCount(inputValueLength: number) {
    return this.maxLength - inputValueLength;
  }

  displayRemainingChars() {
    return `${this.remainingCharacterCount(this.inputValue.length)} characters left`;
  }
  shouldDisplayError() {
    return this.hasError;
  }
  shouldDisplayCharCounter() {
    return this.shouldDisplayCharCount && !this.hasError;
  }
  render() {
    const { inputValue, maxLength, label, rowCount } = this;

    const classList = {
      'has--value': this.inputValue.length > 0,
      'input-multiline__label': true,
      'input-multiline__label--disabled': this.isDisabled,
      'input-multiline__label--default': !this.isDisabled,
    };

    const textAreaClass = {
      'input-multiline__textarea': true,
      'input-multiline__textarea--disabled': this.isDisabled,
      'input-multiline__textarea--error': this.hasError,
    };

    const labelClass = {
      'input-multiline__span': true,
      'input-multiline__span--disabled': this.isDisabled,
    };

    return (
      <div>
        <label class={classList}>
          <textarea
            class={textAreaClass}
            placeholder=""
            value={inputValue}
            onInput={(e) => {
              this.onInputChange(e);
            }}
            disabled={this.isDisabled}
            maxlength={maxLength}
            rows={rowCount}></textarea>
          <span class={labelClass}>{label}</span>
        </label>
        <div>
          {this.shouldDisplayCharCounter() && <span class="input-multiline__remaining-chars">{this.displayRemainingChars()}</span>}
          {this.shouldDisplayError() && <span class="input-multiline__error-message">{`${this.errorMessage}`}</span>}
        </div>
      </div>
    );
  }
}
